module.exports = {"title":"CONTACT","sub_title":"お問い合わせ","description":"株式会社 J・L・Nのお問い合わせページです。WEB制作のご依頼・ご質問・採用に関するご質問などありましたら、お気軽に連絡ください。","canonical":"/company/","comment":"WEB制作のご依頼・ご質問・採用に関するご質問などありましたら、お気軽に連絡ください。","mailto":"info@jln.co.jp"}


//////////////////
// WEBPACK FOOTER
// ./src/config/contact.json
// module id = 531
// module chunks = 0